var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep0Completed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#302322",
    stroke: "#302322"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.875 47.375C31.125 47.75 31.5 47.875 32 47.875C32.4375 47.875 32.8125 47.75 33.125 47.375L51.5625 29C51.8125 28.75 52 28.375 52 27.875C52 27.4375 51.8125 27.0625 51.5625 26.75L49.25 24.5C48.9375 24.1875 48.5625 24 48.125 24C47.6875 24 47.3125 24.1875 47 24.5L32 39.5L25 32.5C24.625 32.1875 24.25 32 23.8125 32C23.375 32 23 32.1875 22.75 32.5L20.4375 34.75C20.125 35.0625 20 35.4375 20 35.875C20 36.375 20.125 36.75 20.4375 37L30.875 47.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep0Completed);
export default __webpack_public_path__ + "static/media/step0-completed.a3d02dcd2c17729e6c27f5e27afb3c0f.svg";
export { ForwardRef as ReactComponent };